import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7883d8fb&lang=pug"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=7883d8fb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports